import React from 'react';
import SEO from '../components/SEO/SEO';
import LayoutTemplate from './layout.template';
import { useLanguage } from '../locales';
import { graphql } from 'gatsby';

const HomeTemplate = (props) => {
  const { translation, lang } = useLanguage();
  const { seo } = translation;
  return (
    <>
      <SEO title={seo.home} lang={lang} pathname={props.path} />
      <LayoutTemplate {...props} />
    </>
  );
};

export const query = graphql`
  query($limit: Int, $skip: Int) {
    blogs: allContentfulBlogPost(
      limit: $limit
      skip: $skip
      sort: { order: DESC, fields: updatedAt }
    ) {
      nodes {
        contentful_id
        title_en
        title_vi
        category
        first_child_category
        second_child_category
        tags
        author
        slug
        description_en
        description_vi
        image {
          fixed(width: 360, height: 360) {
            width
            height
            src
            srcSet
          }
        }
        author
        updatedAt
        createdAt
      }
    }
    countBlogs: allContentfulBlogPost {
      totalCount
    }
    tagsData: allContentfulBlogPost {
      edges {
        node {
          tags
        }
      }
    }
    menuNavsGroups: allContentfulBlogPost {
      group(field: category) {
        nodes {
          category
        }
      }
    }
    history: allContentfulBlogPost {
      nodes {
        createdAt
      }
    }
    recommendedPosts: allContentfulBlogPost(limit: 30) {
      nodes {
        contentful_id
        title_en
        title_vi
        author
        description_en
        description_vi
        category
        first_child_category
        second_child_category
        slug
        tags
        image {
          fixed(width: 360, height: 360) {
            width
            height
            src
            srcSet
          }
        }
        author
        updatedAt
        createdAt
      }
    }
  }
`;

export default HomeTemplate;
